import type {SuggestionItems} from '@Components/input-suggestions-dropdown/input-suggestions-dropdown.types';
import {getBusinessProfilesAddressSuggestion, getBusinessProfilesUrlLinkSuggestions} from '@Components/input-suggestions-dropdown/input-suggestions-library';
import {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {setBusinessAddress, setInputSuggestions} from '@/components/poster-editor/poster-editor-reducer';
import {isUserLoggedIn} from '@Libraries/user.library';

export const useGetLinkInputSuggestions = (): SuggestionItems => {
  const dispatch = useAppDispatch();
  const linkSuggestions = useAppSelector((state) => {
    return state.posterEditor.inputSuggestions;
  });
  const isLoggedIn = isUserLoggedIn();

  useEffect(() => {
    if (isLoggedIn && !linkSuggestions) {
      void getLinkSuggestions();
    }
  }, [isLoggedIn]);

  const getLinkSuggestions = async (): Promise<void> => {
    const smSuggestions = await getBusinessProfilesUrlLinkSuggestions();
    dispatch(setInputSuggestions(smSuggestions));
  };

  return linkSuggestions ?? [];
};

export const useBusinessAddressSuggestion = (): SuggestionItems => {
  const dispatch = useAppDispatch();
  const addressSuggestion = useAppSelector((state) => {
    return state.posterEditor.businessAddressSuggestions;
  });

  useEffect(() => {
    if (!addressSuggestion) {
      void getBusinessAddress();
    }
  }, []);

  const getBusinessAddress = async (): Promise<void> => {
    const businessAddressSuggestion = await getBusinessProfilesAddressSuggestion();
    dispatch(setBusinessAddress(businessAddressSuggestion));
  };

  return addressSuggestion ?? [];
};
